export const SCALES = [
  0.25, 0.33, 0.5, 0.66, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2.0, 2.5, 3.0,
  4.0, 5.0,
];
